export const hotelArrangement: any = {
  stayNum: "{{stayNum}} Night",
};
